<template>
    <v-card elevation="0">
        <v-card-text>
            <v-row no-gutters>
                <v-col>
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                                <!--Year is to be entered from data-->
                                <tr><th class="text-left" colspan="2">Net Tuition Bill - First Installment of {{ netbill['academicyear'] }}</th></tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in first_term"
                                    :key="item.text"
                                >
                                    <td v-html="item.text"></td>
                                    <td> 
                                        <span v-if="item.text != ' ' && netbill.hasOwnProperty(item.value) && netbill[item.value] > 0">${{ netbill[item.value] }}</span>
                                        <span v-if="item.text != ' ' && netbill.hasOwnProperty(item.value) && netbill[item.value] < 0">$({{ netbill[item.value].toString().slice(1) }})</span> 
                                        <span v-if="(item.text != ' ' && !netbill.hasOwnProperty(item.value)) || (item.text != ' ' && netbill.hasOwnProperty(item.value) && netbill[item.value] == 0)">$0.00</span>
                                    </td>
                                </tr>
                                <tr v-if="balanceowingtext1">
                                    <td class="text-caption" colspan="2">Current Balance Owing will be shown to students as $0.00</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col>
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                                <!--Year is to be entered from data-->
                                <tr><th class="text-left" colspan="2">Net Tuition Bill - Second Installment of {{ netbill['academicyear'] }}</th></tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in second_term"
                                    :key="item.text"
                                >
                                    <td v-html="item.text"></td>
                                    <td> 
                                        <span v-if="item.text != ' ' && netbill.hasOwnProperty(item.value) && netbill[item.value] > 0">${{ netbill[item.value] }}</span> 
                                        <span v-if="item.text != ' ' && netbill.hasOwnProperty(item.value) && netbill[item.value] < 0">$({{ netbill[item.value].toString().slice(1) }})</span> 
                                        <span v-if="(item.text != ' ' && !netbill.hasOwnProperty(item.value)) || (item.text != ' ' && netbill.hasOwnProperty(item.value) && netbill[item.value] == 0)">$0.00</span>
                                    </td>
                                </tr>
                                <tr v-if="balanceowingtext2">
                                    <td class="text-caption" colspan="2">Current Balance Owing will be shown to students as $0.00</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props: {
        netbill: {
            required: true
        }
    },
    data(){
        return {
            first_term: [
                {"text": "Balance Carried forward first term", "value": "balancescarriedforward-term1-amount"},
                {"text": "Tuition", "value": "tuition-term1-amount"},
                {"text": "Compulsory Fees", "value": "compfees-term1-amount"},
                {"text": "Health/Dental Plan", "value": "healthdental-term1-amount"},
                {"text": "Bus Pass", "value": "buspass-term1-amount"},
                {"text": "Residence, Meal Plan", "value": "residenceandmeal-term1-amount"},
                {"text": "Other Fees", "value": "otherfees-term1-amount"},
                {"text": "Refund Cheque", "value": "refundcheque-term1-amount"},
                {"text": " ", "value": ""},
                {"text": "Payments/Credits", "value": "payments-term1-amount"},
                {"text": "Insitutional Aid", "value": "institutionalaid-term1-amount"},
                {"text": "OSAP Payments", "value": "osappayments-term1-amount"},
                {"text": "OSAP In Transit", "value": "osap-intransit-term1-amount"},
                {"text": "OSAP Aid Pending", "value": "osap-aidpending-term1-amount"},
                {"text": "Current Balance Owing", "value": "currentbalance-term1-amount"}
            ],
            second_term: [
                {"text": "Balance Carried forward second term", "value": "balancescarriedforward-term2-amount"},
                {"text": "Tuition", "value": "tuition-term2-amount"},
                {"text": "Compulsory Fees", "value": "compfees-term2-amount"},
                {"text": "Health/Dental Plan", "value": "healthdental-term2-amount"},
                {"text": "Bus Pass", "value": "buspass-term2-amount"},
                {"text": "Residence, Meal Plan", "value": "residenceandmeal-term2-amount"},
                {"text": "Other Fees", "value": "otherfees-term2-amount"},
                {"text": "Refund Cheque", "value": "refundcheque-term2-amount"},
                {"text": " ", "value": ""},
                {"text": "Payments/Credits", "value": "payments-term2-amount"},
                {"text": "Insitutional Aid", "value": "institutionalaid-term2-amount"},
                {"text": "OSAP Payments", "value": "osappayments-term2-amount"},
                {"text": "OSAP In Transit", "value": "osap-intransit-term2-amount"},
                {"text": "OSAP Aid Pending", "value": "osap-aidpending-term2-amount"},
                {"text": "Current Balance Owing", "value": "currentbalance-term2-amount"},
            ],
            balanceowingtext1: false,
            balanceowingtext2: false,
        }
    },
    methods: {
        processData(){
            const that = this;
            that.balanceowingtext1 = false;
            that.balanceowingtext2 = false;

            //Study Period && year
            if(that.netbill.hasOwnProperty("applicant-studyperiodstart") && that.netbill.hasOwnProperty("applicant-studyperiodend")){
                that.netbill['applicant-studyperiodstart'] = that.netbill['applicant-studyperiodstart'].slice(0,4)+"/"+that.netbill['applicant-studyperiodstart'].slice(4,6)+"/"+that.netbill['applicant-studyperiodstart'].slice(6,8);
                that.netbill['applicant-studyperiodend'] = that.netbill['applicant-studyperiodend'].slice(0,4)+"/"+that.netbill['applicant-studyperiodend'].slice(4,6)+"/"+that.netbill['applicant-studyperiodend'].slice(6,8);
                that.netbill['yearStart'] = that.netbill['applicant-studyperiodstart'].slice(0,4);
                that.netbill['yearEnd'] = that.netbill['applicant-studyperiodend'].slice(0,4);
                that.netbill['academicyear'] = that.netbill['yearStart']+"-"+that.netbill['yearEnd'];
            }

            //Current Balance Owing (Term 1)
            if(that.netbill.hasOwnProperty("currentbalance-term1-amount") && parseFloat(that.netbill["currentbalance-term1-amount"]) < 0.00){
                that.balanceowingtext1 = true;
            }

            //Current Balance Owing (Term 2)
            if(that.netbill.hasOwnProperty("currentbalance-term2-amount") && parseFloat(that.netbill["currentbalance-term2-amount"]) < 0.00){
                that.balanceowingtext2 = true;
            }
        }
    },
    created(){
        const that = this;
        that.processData();
    }
}
</script>